import { TableCellWrapper } from 'components/quotation-editor/shared/TableCellWrapper';
import React, { useMemo } from 'react';
import useQuotation from '../../../../hooks/quotations/useQuotation';
import {
    QuotationSummariesTableItem,
    QuotationSummaryProdTableItem,
} from '../../../../models/quotations/Quotation';
import { QuotationSummaryData } from '../../../../models/quotations/Quotations';
import {
    QuotationEditProductsTableHead,
    QuotationSummariesTableHead,
} from '../../../../utils/constans/tableHeads/quotationEditProductsTableHead';
import { BasicTable } from '../../BasicTable/BasicTable';
import { QuotationSummaryProdTableRow } from './products-table-components/QuotationSummaryProdTableRow';
import { QuotationSummariesTableRow } from './summary-table-components/QuotationSummariesTableRow';

export const StyledTableCellWrapper = (props: {
    children?: React.ReactNode;
    type?: string;
}) => {
    return (
        <TableCellWrapper style={{ py: '5px' }} type={props.type}>
            {props.children}
        </TableCellWrapper>
    );
};

export const QuotationSummaryProducts: React.FC<{
    quoteData: QuotationSummaryData;
}> = (props) => {
    const { quoteData } = props;

    const quotation = useQuotation();

    const tableHeadSettings = {
        translateNs: 'quotations',
        translatePrefix:
            'QUOTATIONS.QUOTATION_EDITOR.SUMMARY.PRODUCTS.TABLE_HEAD',
        selectable: false,
        headContent: QuotationEditProductsTableHead,
    };
    const summariesTableHeadSettings = {
        translateNs: 'quotations',
        translatePrefix:
            'QUOTATIONS.QUOTATION_EDITOR.SUMMARY.PRODUCTS.TABLE_HEAD',
        selectable: false,
        headContent: QuotationSummariesTableHead,
    };

    const summariesData = useMemo(
        (): QuotationSummariesTableItem[] =>
            quotation.getSummariesPrices(quoteData),
        [quotation.getSummariesPrices, quoteData]
    );

    const convertDatas = useMemo(
        () => [
            ...quotation.convertItemsToTable(quoteData.items),
            ...quotation.convertCustomItemsToTable(quoteData.custom_items),
        ],
        [
            quotation.convertCustomItemsToTable,
            quotation.convertItemsToTable,
            quoteData?.items,
            quoteData?.custom_items,
        ]
    );

    /*const firstTableRef = useRef<HTMLDivElement>();
    const secondTableRef = useRef<HTMLDivElement>();

    const handleScrollFirst = (scroll) => {
        secondTableRef.current.scrollLeft = scroll.target.scrollLeft;
    };

    const handleScrollSecond = (scroll) => {
        firstTableRef.current.scrollLeft = scroll.target.scrollLeft;
    };*/

    return (
        <div
            style={{
                overflowX: 'scroll',
            }}
        >
            <BasicTable<
                QuotationSummaryProdTableItem,
                QuotationSummaryProdTableItem
            >
                fullList={convertDatas}
                tableHeadSettings={tableHeadSettings}
                component={QuotationSummaryProdTableRow}
                wrapperStyles={{ overflow: 'visible' }}
                // wrapperRef={firstTableRef}
                // onWrapperScroll={handleScrollFirst}
            />
            {convertDatas.length > 0 && (
                <BasicTable<
                    QuotationSummariesTableItem,
                    QuotationSummaryProdTableItem
                >
                    fullList={summariesData}
                    tableHeadSettings={summariesTableHeadSettings}
                    component={QuotationSummariesTableRow}
                    wrapperStyles={{ overflow: 'visible' }}
                    // wrapperRef={secondTableRef}
                    // onWrapperScroll={handleScrollSecond}
                />
            )}
        </div>
    );
};
